import React, { useEffect, useState } from 'react';
import { Modal, Spinner, Table } from 'react-bootstrap';
import { payrollAPI } from '../../services';
import { toast } from 'react-toastify';
import { format } from 'date-fns';

const formatDateTime = (value) => {
  if (!value) return '-';
  try {
    return format(new Date(value), 'dd/MM/yyyy HH:mm');
  } catch {
    return value;
  }
};

const formatDate = (value) => {
  if (!value) return '-';
  try {
    return format(new Date(value), 'dd/MM/yyyy');
  } catch {
    return value;
  }
};

export default function HoursDetailModal({ show, onHide, payrollId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && payrollId) {
      fetchHoursDetail();
    } else {
      setData(null);
    }
  }, [show, payrollId]);

  const fetchHoursDetail = async () => {
    try {
      setLoading(true);
      const response = await payrollAPI.getHoursDetail(payrollId);
      setData(response);
    } catch (error) {
      console.error('Cannot fetch hours detail', error);
      toast.error(error?.message || 'Không tải được chi tiết giờ làm việc');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Chi tiết giờ làm việc</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        )}

        {!loading && !data && <div className="text-muted">Không có dữ liệu</div>}

        {!loading && data && (
          <>
            {data.summary && (
              <div className="mb-4 p-3 bg-light rounded">
                <h6 className="mb-3">Tóm tắt</h6>
                <div className="row">
                  <div className="col-md-4">
                    <div>
                      <strong>Số ca làm thường:</strong> {data.summary.normal || 0}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div>
                      <strong>Số ca làm đêm:</strong> {data.summary.overnight || 0} (x1.5)
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div>
                      <strong>Số ca làm lễ:</strong> {data.summary.holiday || 0} (x2.0)
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <strong>Giờ quy đổi tổng:</strong> {data.summary.total || 0}h
                </div>
              </div>
            )}

            {data.shifts && data.shifts.length > 0 ? (
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Ngày</th>
                    <th>Thời gian</th>
                    <th>Loại</th>
                    <th>Hệ số</th>
                    <th>Giờ</th>
                    <th>Giờ quy đổi</th>
                  </tr>
                </thead>
                <tbody>
                  {data.shifts.map((shift) => (
                    <tr key={shift.id}>
                      <td>{formatDate(shift.date || shift.start_time)}</td>
                      <td>
                        {shift.start_time && formatDateTime(shift.start_time)}
                        {shift.end_time && ` - ${formatDateTime(shift.end_time)}`}
                      </td>
                      <td>
                        {shift.type === 'normal' && 'Thường'}
                        {shift.type === 'overnight' && 'Đêm'}
                        {shift.type === 'holiday' && 'Lễ'}
                        {!shift.type && '-'}
                      </td>
                      <td>{shift.multiplier || 1}</td>
                      <td>{shift.hours || 0}h</td>
                      <td>
                        <strong>{shift.converted_hours || shift.hours || 0}h</strong>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center text-muted py-4">Không có ca làm việc</div>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
}

